module.exports = "/images/vendor/leaflet/dist/layers-2x.png?4f0283c6ce28e888000e978e537a6a56";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/layers-2x.png
// module id = Ryzh
// module chunks = 58